import { ClientEvent } from '@udemy/event-tracking';
import { getRequestData } from '@udemy/shared-utils';

/**
 * Provides additional properties
 * for any object that can be tracked
 */

/**
 * A minimal representation of a buyable, or purchasable, item
 * used for event tracking
 */

/**
 * Auto Complete Item for eventing
 */

export let BackendSourceOptions = /*#__PURE__*/function (BackendSourceOptions) {
  BackendSourceOptions["DISCOVERY"] = "discovery";
  BackendSourceOptions["TAUGHT_COURSES"] = "taught_courses";
  BackendSourceOptions["USER_PROFILE_COURSES"] = "user_profile_courses";
  BackendSourceOptions["USER_WISHLISTED_COURSES"] = "user_wishlisted_courses";
  BackendSourceOptions["USER_COLLECTIONS"] = "user_collections";
  BackendSourceOptions["RELATED_LECTURES"] = "related_lectures";
  BackendSourceOptions["SHOPPING_CARTS"] = "shopping_carts";
  BackendSourceOptions["DISCOVERY_ALL_COURSES"] = "discovery_all_courses";
  BackendSourceOptions["SEARCH_RECOMMENDATIONS"] = "search_recommendations";
  BackendSourceOptions["AI_ASSISTANT"] = "ai_assistant";
  BackendSourceOptions["CERTIFICATION_AGGREGATORS"] = "certification_aggregators";
  return BackendSourceOptions;
}({});

/**
 * Fired when a discovery item is seen by a user
 */
export class DiscoveryItemImpressionEvent extends ClientEvent {
  constructor({
    id,
    type,
    trackingId,
    serveTrackingId,
    backendSource,
    position,
    badgeFamilies,
    relatedSourceId,
    relatedSourceType,
    uiRegion = null
  }) {
    var _badgeFamilies$map;
    super('DiscoveryItemImpressionEvent');
    this.id = void 0;
    this.type = void 0;
    this.trackingId = void 0;
    this.serveTrackingId = void 0;
    this.backendSource = void 0;
    this.position = void 0;
    this.badges = void 0;
    this.relatedSourceId = void 0;
    this.relatedSourceType = void 0;
    this.uiRegion = void 0;
    this.id = id;
    this.type = type;
    this.trackingId = trackingId;
    this.serveTrackingId = serveTrackingId;
    this.backendSource = backendSource;
    this.position = position;
    this.badges = (_badgeFamilies$map = badgeFamilies === null || badgeFamilies === void 0 ? void 0 : badgeFamilies.map(family => ({
      family
    }))) !== null && _badgeFamilies$map !== void 0 ? _badgeFamilies$map : null;
    this.relatedSourceId = relatedSourceId;
    this.relatedSourceType = relatedSourceType;
    this.uiRegion = uiRegion;
  }
}

/**
 * Fired when a discovery item is clicked by a user
 */
DiscoveryItemImpressionEvent.backendSourceOptions = {
  DISCOVERY: BackendSourceOptions.DISCOVERY,
  TAUGHT_COURSES: BackendSourceOptions.TAUGHT_COURSES,
  USER_PROFILE_COURSES: BackendSourceOptions.USER_PROFILE_COURSES,
  USER_WISHLISTED_COURSES: BackendSourceOptions.USER_WISHLISTED_COURSES,
  USER_COLLECTIONS: BackendSourceOptions.USER_COLLECTIONS,
  RELATED_LECTURES: BackendSourceOptions.RELATED_LECTURES,
  SHOPPING_CARTS: BackendSourceOptions.SHOPPING_CARTS,
  DISCOVERY_ALL_COURSES: BackendSourceOptions.DISCOVERY_ALL_COURSES,
  SEARCH_RECOMMENDATIONS: BackendSourceOptions.SEARCH_RECOMMENDATIONS,
  CERTIFICATION_AGGREGATORS: BackendSourceOptions.CERTIFICATION_AGGREGATORS
};
export class DiscoveryItemClickEvent extends ClientEvent {
  constructor({
    id,
    type,
    trackingId,
    serveTrackingId,
    backendSource,
    position = 0,
    badgeFamilies,
    uiRegion = null
  }) {
    var _badgeFamilies$map2;
    super('DiscoveryItemClickEvent');
    this.id = void 0;
    this.type = void 0;
    this.trackingId = void 0;
    this.serveTrackingId = void 0;
    this.backendSource = void 0;
    this.position = void 0;
    this.badges = void 0;
    this.uiRegion = void 0;
    this.id = id;
    this.type = type;
    this.trackingId = trackingId;
    this.serveTrackingId = serveTrackingId;
    this.backendSource = backendSource;
    this.position = position;
    this.badges = (_badgeFamilies$map2 = badgeFamilies === null || badgeFamilies === void 0 ? void 0 : badgeFamilies.map(family => ({
      family
    }))) !== null && _badgeFamilies$map2 !== void 0 ? _badgeFamilies$map2 : null;
    this.uiRegion = uiRegion;
  }
}

/**
 * Fired when a discovery unit is seen by a user
 */
export class DiscoveryUnitViewEvent extends ClientEvent {
  constructor({
    trackingId,
    unitTitle,
    renderType
  }) {
    super('DiscoveryUnitViewEvent');
    this.trackingId = void 0;
    this.title = void 0;
    this.renderType = void 0;
    this.trackingId = trackingId;
    this.title = unitTitle;
    this.renderType = renderType;
  }
}

/**
 This event is fired when a user sees any UFB notice link on a marketplace page
 **/
export class UFBNoticeImpressionEvent extends ClientEvent {
  constructor({
    locale = getRequestData().locale,
    placement,
    url = null
  }) {
    super('UFBNoticeImpressionEvent');
    this.locale = void 0;
    this.placement = void 0;
    this.url = void 0;
    this.locale = locale;
    this.placement = placement;
    this.url = url;
  }
  get eventLocale() {
    return this.locale;
  }
  get eventPlacement() {
    return this.placement;
  }
}
export let UFBNoticeVariant = /*#__PURE__*/function (UFBNoticeVariant) {
  UFBNoticeVariant["TEAM_ACCESS"] = "team_access";
  UFBNoticeVariant["COURSES_AND_CERTS"] = "courses_and_certs";
  UFBNoticeVariant["COMPANIES_TRUST"] = "companies_trust";
  UFBNoticeVariant["COURSES_AND_PATHS"] = "courses_and_paths";
  return UFBNoticeVariant;
}({});

/**
 This event is fired when a user clicks on any UFB notice link on a marketplace page
 */
export class UFBNoticeClickEvent extends ClientEvent {
  constructor({
    locale = getRequestData().locale,
    placement,
    variant = null,
    url = null
  }) {
    super('UFBNoticeClickEvent');
    this.locale = void 0;
    this.placement = void 0;
    this.variant = void 0;
    this.url = void 0;
    this.locale = locale;
    this.placement = placement;
    this.variant = variant;
    this.url = url;
  }
  get eventLocale() {
    return this.locale;
  }
  get eventPlacement() {
    return this.placement;
  }
  get eventVariant() {
    return this.variant;
  }
}

/**
 * Fired when user clicks the 'Buy Now' button
 */
export class BuyNowEvent extends ClientEvent {
  constructor({
    buyable
  }) {
    super('BuyNowEvent');
    this.buyable = void 0;
    this.buyable = buyable;
  }
}

/**
 * Fired when user clicks the 'Enroll now' button
 */
export class EnrollNowEvent extends ClientEvent {
  constructor({
    buyable
  }) {
    super('EnrollNowEvent');
    this.buyable = void 0;
    this.buyable = buyable;
  }
}

/**
 * Fired when quick view is viewed by a user
 */
export class QuickViewBoxOpenEvent extends ClientEvent {
  constructor({
    id,
    type,
    trackingId
  }) {
    super('QuickViewBoxOpenEvent');
    this.id = void 0;
    this.type = void 0;
    this.trackingId = void 0;
    this.id = id;
    this.trackingId = trackingId;
    this.type = type;
  }
}

/**
 * Fired when user clicks the 'Wishlist' button
 */
export class WishlistEvent extends ClientEvent {
  constructor({
    id,
    trackingId
  }) {
    super('WishlistEvent');
    this.id = void 0;
    this.trackingId = void 0;
    this.id = id;
    this.trackingId = trackingId;
  }
}

/**
 * Fire when an auto-complete item is clicked
 */
export class AutoCompleteItemClickEvent extends ClientEvent {
  constructor({
    resultTrackingId,
    autoCompleteItem
  }) {
    super('AutoCompleteItemClickEvent');
    this.resultTrackingId = void 0;
    this.autoCompleteItem = void 0;
    this.resultTrackingId = resultTrackingId;
    this.autoCompleteItem = autoCompleteItem;
  }
}

/**
 * Fired when auto-complete results are displayed to user
 */
export class AutoCompleteResultImpressionEvent extends ClientEvent {
  constructor({
    resultTrackingId,
    query
  }) {
    super('AutoCompleteResultImpressionEvent');
    this.resultTrackingId = void 0;
    this.query = void 0;
    this.resultTrackingId = resultTrackingId;
    this.query = query;
  }
}

/**
 * Fired when user bounces from auto-complete results
 */
export class AutoCompleteResultBounceEvent extends ClientEvent {
  constructor({
    resultTrackingId
  }) {
    super('AutoCompleteResultBounceEvent');
    this.resultTrackingId = void 0;
    this.resultTrackingId = resultTrackingId;
  }
}

/**
 * Fired when user switches to MX or consumer subscription only courses in search and browse pages.
 */

export class CollectionTypeSwitchEvent extends ClientEvent {
  constructor({
    query,
    resultCount,
    toCollectionType,
    fromCollectionType
  }) {
    super('CollectionTypeSwitchEvent');
    this.query = void 0;
    this.resultCount = void 0;
    this.fromCollectionType = void 0;
    this.toCollectionType = void 0;
    this.query = query;
    this.resultCount = resultCount;
    this.fromCollectionType = fromCollectionType;
    this.toCollectionType = toCollectionType;
  }
}

/**
 * Fires when a user manually changes the language sort option provided by search QLI
 */
export class SearchInferenceLanguageChangeEvent extends ClientEvent {
  constructor(language, trackingId) {
    super('SearchInferenceLanguageChangeEvent');
    this.language = language;
    this.trackingId = trackingId;
  }
}

/**
 *  Fired when filters are applied on course directory in search and browse pages.
 */

export class DirectoryFilterChangeEvent extends ClientEvent {
  constructor({
    query,
    aggregation,
    option,
    isCheckedOnClick
  }) {
    super('DirectoryFilterChangeEvent');
    this.query = void 0;
    this.aggregation = void 0;
    this.option = void 0;
    this.isCheckedOnClick = void 0;
    this.query = query;
    this.aggregation = aggregation;
    this.option = option;
    this.isCheckedOnClick = isCheckedOnClick;
  }
}
export class OccupationCardImpressionEvent extends ClientEvent {
  constructor({
    occupationId,
    occupationName,
    index,
    uiRegion
  }) {
    super('OccupationCardImpressionEvent');
    this.occupationId = void 0;
    this.occupationName = void 0;
    this.index = void 0;
    this.uiRegion = void 0;
    this.occupationId = occupationId;
    this.occupationName = occupationName;
    this.index = index;
    this.uiRegion = uiRegion;
  }
}
export class OccupationCardClickEvent extends ClientEvent {
  constructor({
    occupationId,
    occupationName,
    index,
    uiRegion
  }) {
    super('OccupationCardClickEvent');
    this.occupationId = void 0;
    this.occupationName = void 0;
    this.index = void 0;
    this.uiRegion = void 0;
    this.occupationId = occupationId;
    this.occupationName = occupationName;
    this.index = index;
    this.uiRegion = uiRegion;
  }
}

/**
 This event is fired when a user interacts with flow progressing elements in
 the Occupation exploration process
 TODO: OccupationFlowProgressionEvent will deprecate after MX integration of the new learner goal colletion
 */
export class OccupationFlowProgressionEvent extends ClientEvent {
  constructor(progression, selection, selectionType) {
    super('OccupationFlowProgressionEvent');
    this.progression = progression;
    this.selection = selection;
    this.selectionType = selectionType;
    this.progression = progression;
    this.selection = selection;
    this.selectionType = selectionType;
  }
}

/**
 * Fired when a user selects to add their occupation, certification, or skill goal
 */
export class AddCareerGoalSelected extends ClientEvent {
  constructor(targetPage, uiRegion) {
    super('AddCareerGoalSelected');
    this.targetPage = targetPage;
    this.uiRegion = uiRegion;
    this.targetPage = targetPage;
    this.uiRegion = uiRegion;
  }
}

/**
 * Fired when a user selects to update their occupation, certification, or skill goal
 */
export class UpdateCareerGoalSelected extends ClientEvent {
  constructor(targetPage, uiRegion) {
    super('UpdateCareerGoalSelected');
    this.targetPage = targetPage;
    this.uiRegion = uiRegion;
    this.targetPage = targetPage;
    this.uiRegion = uiRegion;
  }
}
export class DiscoveryUnitTabPresented extends ClientEvent {
  constructor({
    topic,
    position,
    uiRegion
  }) {
    super('DiscoveryUnitTabPresented');
    this.topic = void 0;
    this.position = void 0;
    this.uiRegion = void 0;
    this.topic = topic;
    this.position = position;
    this.uiRegion = uiRegion;
  }
}
export class DiscoveryUnitTabSelected extends ClientEvent {
  constructor({
    topic,
    position,
    uiRegion
  }) {
    super('DiscoveryUnitTabSelected');
    this.topic = void 0;
    this.position = void 0;
    this.uiRegion = void 0;
    this.topic = topic;
    this.position = position;
    this.uiRegion = uiRegion;
  }
}
export let BrowseNavigationItemType = /*#__PURE__*/function (BrowseNavigationItemType) {
  BrowseNavigationItemType["TOPIC"] = "topic";
  BrowseNavigationItemType["CATEGORY"] = "category";
  BrowseNavigationItemType["SUBCATEGORY"] = "subcategory";
  BrowseNavigationItemType["BADGE"] = "badge";
  BrowseNavigationItemType["RECOMMENDATION_COLLECTION"] = "recommendation_collection";
  BrowseNavigationItemType["CERTIFICATION_PREPARATION"] = "certification_preparation";
  BrowseNavigationItemType["CERTIFICATION_ISSUER_AGGREGATOR"] = "certification_issuer_aggregator";
  BrowseNavigationItemType["CERTIFICATION_SUBJECT_AGGREGATOR"] = "certification_subject_aggregator";
  BrowseNavigationItemType["AI_COURSES"] = "ai_courses";
  BrowseNavigationItemType["ALL_CERTIFICATION_VOUCHERS"] = "all_certification_vouchers";
  BrowseNavigationItemType["CERTIFICATION_VOUCHER"] = "certification_voucher";
  BrowseNavigationItemType["CERTIFICATION_VOUCHER_PROVIDER"] = "certification_provider";
  BrowseNavigationItemType["LEARN_AI"] = "learn_ai";
  return BrowseNavigationItemType;
}({});
export let BrowseNavigationItemStyle = /*#__PURE__*/function (BrowseNavigationItemStyle) {
  BrowseNavigationItemStyle["PILL_DARK"] = "pill_dark";
  BrowseNavigationItemStyle["PILL_LIGHT"] = "pill_light";
  BrowseNavigationItemStyle["PILL_VISUAL"] = "pill_visual";
  BrowseNavigationItemStyle["BLOCK"] = "block";
  BrowseNavigationItemStyle["NAVIGATION_TAB"] = "navigation_tab";
  BrowseNavigationItemStyle["NAVIGATION_DROPDOWN"] = "navigation_dropdown";
  BrowseNavigationItemStyle["LINK"] = "link";
  return BrowseNavigationItemStyle;
}({});
export class BrowseNavigationItemSelected extends ClientEvent {
  constructor({
    id,
    type,
    uiRegion,
    style,
    relatedEntityId,
    relatedEntityType
  }) {
    super('BrowseNavigationItemSelected');
    this.id = void 0;
    this.type = void 0;
    this.uiRegion = void 0;
    this.style = void 0;
    this.relatedEntityId = void 0;
    this.relatedEntityType = void 0;
    this.id = id;
    this.type = type;
    this.uiRegion = uiRegion;
    this.style = style;
    this.relatedEntityId = relatedEntityId;
    this.relatedEntityType = relatedEntityType;
  }
}
export class BlogCTAImpressionEvent extends ClientEvent {
  constructor({
    url,
    currentUrl
  }) {
    super('BlogCTAImpressionEvent');
    this.url = void 0;
    this.currentUrl = void 0;
    this.url = url;
    this.currentUrl = currentUrl;
  }
}
export class BlogCTAClickEvent extends ClientEvent {
  constructor({
    url,
    currentUrl
  }) {
    super('BlogCTAClickEvent');
    this.url = void 0;
    this.currentUrl = void 0;
    this.url = url;
    this.currentUrl = currentUrl;
  }
}
export class LectureArticleSelected extends ClientEvent {
  constructor({
    lectureId,
    courseId,
    lectureType
  }) {
    super('LectureArticleSelected');
    this.lecture = void 0;
    this.course = void 0;
    this.lecture = {
      id: lectureId,
      type: lectureType
    };
    this.course = {
      id: courseId
    };
  }
}
//# sourceMappingURL=events.js.map